// Crisis Resources - Single Source of Truth
// Update these details here and they will propagate to all disclaimers in the app

export const CRISIS_RESOURCES = {
  country: "South Africa",
  primaryCrisisLine: {
    name: "SADAG Suicide Crisis Helpline",
    phone: "0800 567 567",
    hours: "24 hours",
    sms: "31393",
    smsNote: "for a call-back"
  },
  referralLine: {
    name: "SADAG Mental Health Line",
    phone: "011 234 4837",
    hours: "8am to 8pm daily",
    purpose: "referral to a psychologist or psychiatrist"
  }
};

export const DISCLAIMER_TEXT = `Compass supports self-direction. It is not therapy, medical care, or a substitute for professional help. If you are struggling, please speak to a qualified professional. In ${CRISIS_RESOURCES.country}, the ${CRISIS_RESOURCES.primaryCrisisLine.name} is ${CRISIS_RESOURCES.primaryCrisisLine.phone}, available ${CRISIS_RESOURCES.primaryCrisisLine.hours}, or SMS ${CRISIS_RESOURCES.primaryCrisisLine.sms} ${CRISIS_RESOURCES.primaryCrisisLine.smsNote}. For a ${CRISIS_RESOURCES.referralLine.purpose}, ${CRISIS_RESOURCES.referralLine.name} is ${CRISIS_RESOURCES.referralLine.phone}, open ${CRISIS_RESOURCES.referralLine.hours}.`;
